import { DynamicSchema } from '@soniq/schema'
import { ProfileSchema } from '../../.types/Profile.schema'
import { definitions } from '../../.types/Profile.schema.json'

export type { ProfileSchema } from '../../.types/Profile.schema'
export const profileJsonSchema = {
  ...definitions.ProfileSchema,
  definitions,
}
export const profileSchema = DynamicSchema.new<ProfileSchema>({
  id: 'ProfileSchema',
  jsonSchema: profileJsonSchema,
})
export * from './guards'
export * from './validation'
export * from './types'
